<template>
  <FlexLayout role="region">
    <BlockContainer :title="$t('orderParameters.subTitle.shopSelection')">
      <Shops @shop-selected="onShopSelected" :shop-id="this.shopId" />
    </BlockContainer>
    <BlockContainer :title="$t('orderParameters.subTitle.shopParameters')" ref="shopParametersBlock"
    >
      <div class="centered-message" v-if="!selectedShop">
        <p>
          <FontAwesomeIcon :icon="['fas', 'circle-info']" />
          {{ $t('orderParameters.label.selectShop') }}
        </p>
      </div>
      <template v-if="selectedShop">
        <ShopParameters
          :selectedShop="selectedShop"
          :key="selectedShop.id"
          @input-change="onShopInputChange"
          ref="shopParameters"
        />
      </template>
      <template v-if="selectedShop" v-slot:actions>
        <Button
          variant="primary"
          :disabled="!canSubmitShopParameters"
          @click="$refs.shopParameters.submit()"
        >{{ $t('orderParameters.button.showOrderMenu') }}</Button>
      </template>
    </BlockContainer>
  </FlexLayout>
</template>

<script>
import BlockContainer from "@/components/layout/BlockContainer.vue";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ShopParameters from "@/components/page-components/Shop/ShopParameters.vue";
import Shops from "@/components/page-components/Shop/Shops.vue";
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";
import Button from "@/components/actions/Button.vue";

export default {
  components: {
    Button,
    FlexLayout,
    BlockContainer,
    FontAwesomeIcon,
    Shops,
    ShopParameters,
  },
  props: {
    shopId: {
      type: [String, Number],
      required: false
    }
  },
  data() {
    return {
      selectedShop: null,
      shopParametersInput: {
        selectedOrderType: null,
        selectedDate: null,
        selectedTimeSlot: null,
      },
    }
  },
  computed: {
    canSubmitShopParameters() {
      const i = this.shopParametersInput;
      return !!(i.selectedOrderType && i.selectedDate && i.selectedTimeSlot);
    },
  },
  methods: {
    onShopSelected(shop) {
      this.selectedShop = shop;
      // Fetch time slots immediately after selecting a shop
      this.$nextTick(() => {
        if (this.$refs.shopParameters) {
          this.$refs.shopParameters.fetchTimeSlots();
        }
        if (this.$refs.shopParametersBlock && this.$refs.shopParametersBlock.$el) {
          this.$refs.shopParametersBlock.$el.scrollIntoView({ behavior: 'smooth' });
        }
      });
    },
    onShopInputChange(input) {
      this.shopParametersInput = input;
    },
  },
}
</script>

<style scoped>
.centered-message {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%; /* Fill BlockContainer */
}
.centered-message p {
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  gap: 0.5em;
}
</style>
